import { DateTime } from 'luxon';

export const formatDate = (val, nullVal) => {
  let result = nullVal || '';

  if(val !== null) {
    result = DateTime.fromISO(val).toFormat('f');
  }

  return result;
}

export const formatDateDefault = nullVal => {
  return function(val, overrideVal) {
    let nullDefault = overrideVal || nullVal;

    return formatDate(val, nullDefault);
  }
}

export const getResponses = (question) => {
  if(!question.isRandomized) {
    return question.responses.map(response => {
      return response;
    });
  }
  else {
    let exclusionAry = [];

    if(question.unrandomizedResponses) {
      exclusionAry = question.unrandomizedResponses.split(',');
    }

    let randomAry = randomizeResponses(question.responses, exclusionAry);

    return randomAry;
  }
}

export const randomizeResponses = (ary, exclusionAry) => {
  let responseOrdinals = ary.map(response => {
    return response.responseOrdinal - 1;
  });
  let ordExclusionArray = [];
  let randomizedAry = [];

  if(!Array.isArray(exclusionAry)) {
    exclusionAry = [];
  }

  exclusionAry.forEach(responseId => {
    let ind = ary.findIndex(response => response.hspResponseId == responseId);

    if(ind >= 0) {
      ordExclusionArray.push(ind);
    }
  });

  randomizeArray(responseOrdinals, ordExclusionArray);

  let counter = 0;

  responseOrdinals.forEach(ordinal => {
    randomizedAry[counter] = ary[ordinal];
    counter++;
  });

  return randomizedAry;
}

// exclusionAry only works with value types.
export const randomizeArray = (ary, exclusionAry) => {
  let currentIndex = ary.length - 1;

  if(!Array.isArray(exclusionAry)) {
    exclusionAry = [];
  }

  while(currentIndex >= 0) {
    let randomVal = Math.floor(Math.random() * ary.length);
    let tempVal = ary[currentIndex];

    if(exclusionAry.indexOf(ary[randomVal]) >= 0) {
      continue;
    }

    if(!(exclusionAry.indexOf(ary[currentIndex]) >= 0)) {
      ary[currentIndex] = ary[randomVal];
      ary[randomVal] = tempVal;
    }

    currentIndex--
  }
}

// Determines if a value is true. If it contains 'no', 'false', 'none', '0', 
// or '000' (any number of zeros in the string), or is null, undefined, or empty, then it's false.
export const isTrue = (value) => {
  if (isNullOrEmpty(value)) {
    return false;
  }

  let stringValue = value.toString().toLowerCase();
  if (stringValue === 'no' || stringValue === 'false' || stringValue === 'none' ||
      stringValue.split('0').filter(Boolean).length === 0) {
    return false;
  }

  return true;
}

// For responsive adjustments. Width greater than or equal to 768px is desktop size.
// Otherwise, mobile/tablet size.
export const isDesktopSize = (/** @type {number} */ windowWidth) => {
  if (windowWidth >= 768) {
    return true;
  }

  return false;
}

// Generates a random alphanumeric string with size 'length' containing the amount/number of numbers given by 'digits'.
// @param {*} length The size of the code
// @param {*} digits The number of numbers the code contains
// @returns alphanumeric string
export const randomCode = (/** @type {number} */ length, /** @type {number} */ digits = 0) => {
  const numbers = "1234567890"; // number characters only
  const characters = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"; // characters used in string
  let result = "";
  for (let i = length; i > 0; i--) {
      result += characters[Math.floor(Math.random() * characters.length)];
  }

  // Ensure the random code contains at least a number of numbers specified by 'digits'.
  let resultList = result.split('');
  let numList = resultList.filter(x => numbers.indexOf(x) > -1);
  if (numList.length < digits) {
    return randomCode(length, digits);
  }
    
  return result;
}

export const isNullOrEmpty = (/** @type {any} */ obj) => {
  return typeof obj === "undefined" || !obj || obj.length === 0;
}

export const completedMessage = (/** @type {any} */ section) => {
  if (isNullOrEmpty(section.sectionHeader)) {
    return null;
  }

  const name = section.sectionName.toLowerCase();

  return name.indexOf("completed") >=0 ? section.sectionHeader : null;
}

export const isDarkMode = () => {
  return !document.body.classList.contains("white-content");
}

export const isDarkModeMedia = () => {
  return window?.matchMedia?.("(prefers-color-scheme: dark)")?.matches ?? false;
}

export const preventDarkMode = () => {
  if (isDarkMode()) {
    document.body.classList.add("white-content");
  }
}

export const copyObject = (obj) => {
  return JSON.parse(JSON.stringify(obj));
}